import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    Button, Image, AutoCenter, Toast, NoticeBar,
    Dialog
} from 'antd-mobile'
import Icon from '../icon'
import './closeInfo.css'
import { useNavigate } from 'react-router-dom'
import API_ROUTES from '../api'
import axios from 'axios'

import MatchResultDisplay from './matchResultDisplay'
import GetSinglePersonFire from '../Applicate/ApplicateOne/getSInglePersonFire'
import { useAuth } from '../app/providers/AuthProvider'
import RegistrationActions from '../features/match/components/RegistrationActions'

const CloseInfo = ({ gameDetail, mvpDataInfo, getCloseGameInfo, getGameInfo }) => {

    const navigate = useNavigate()
    const { memberInfo } = useAuth()

    const [memberBirthDay, setMemberBirthDay] = useState([])
    const [gameEventInfo, setGameEventInfo] = useState([])
    const [liveGameSnapshot, setLiveGameSnapshot] = useState(null)
    // 进行中的比赛每秒更新时间基准，让首页计时无需手动刷新即可持续变化。
    const [liveNow, setLiveNow] = useState(() => Date.now())
    const liveSnapshotRequestRef = useRef(false)
    const liveStatusRefreshRequestedRef = useRef(false)
    const serverClockOffsetRef = useRef(0)
    // 内讧赛 MVP 提示保留在比赛卡片中，报名操作交给共用组件处理。
    const isInternalGame = Number(gameDetail?.gameType) === 3
    // 管理员操作报名时不展示普通队员的 MVP 投票门槛。
    const mvpVotePending = Number(memberInfo?.admin) !== 1 && isInternalGame && !mvpDataInfo?.checking && mvpDataInfo?.gameId && !mvpDataInfo?.likeMemberId

    // Team naming logic synchronized across the application
    const getTeamName = (teamIndex) => {
        const defaultName = teamIndex === 1 ? 'A队' : 'B队'
        const savedName = teamIndex === 1 ? gameDetail?.greenName : gameDetail?.redName
        // 内讧赛的“A队/B队”是未命名时的占位值，首页优先显示当前队长的姓氏。
        const hasCustomName = typeof savedName === 'string' && savedName.trim()
            && !(Number(gameDetail?.gameType) === 3 && savedName.trim() === defaultName)
        if (teamIndex === 1) {
            // 正式赛、活动赛在首页统一展示俱乐部名称，不使用比赛表中的临时第一队队名。
            if ([1, 2].includes(gameDetail?.gameType)) return '华西科朋足球队';
            if (hasCustomName) return savedName.trim();
            const captainName = gameDetail?.greenCaptain?.name || gameDetail?.greenCaptain;
            if (typeof captainName === 'string' && captainName) return captainName.charAt(0) + '队';
            return defaultName;
        } else if (teamIndex === 2) {
            if (hasCustomName) return savedName.trim();
            const captainName = gameDetail?.redCaptain?.name || gameDetail?.redCaptain;
            if (typeof captainName === 'string' && captainName) return captainName.charAt(0) + '队';
            return defaultName;
        }
        return 'Team'
    }

    const getPreparedMatchStatusText = () => {
        if (gameDetail?.greenCaptainConfirm === 0 && gameDetail?.redCaptainConfirm === 0) {
            return `待${gameDetail.greenCaptain?.name || gameDetail.greenCaptain || '队长'}调阵`;
        }
        if (gameDetail?.greenCaptainConfirm === 1 && gameDetail?.redCaptainConfirm === 0) {
            return `待${gameDetail.redCaptain?.name || gameDetail.redCaptain || '队长'}选队`;
        }
        if (
            (gameDetail?.redCaptainConfirm === 2 && gameDetail?.greenCaptainConfirm === 1) ||
            (gameDetail?.redCaptainConfirm === 1 && gameDetail?.greenCaptainConfirm === 2) ||
            (gameDetail?.redCaptainConfirm === 1 && gameDetail?.greenCaptainConfirm === 1)
        ) {
            return '待双方队长排首发';
        }
        if (gameDetail?.redCaptainConfirm === 2 && gameDetail?.greenCaptainConfirm === 2) {
            return '阵容已确认，等待开赛';
        }
        return '等待比赛开始';
    }

    const getBirthdayInfo = useCallback(() => {
        axios.get(API_ROUTES.game_birthday, {
            params: {
                gameId: gameDetail.id
            }
        }, null)
            .then(function (response) {
                setMemberBirthDay(response.data.data)
                Toast.clear()
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameDetail?.id])

    const getGameEventInfo = useCallback(() => {
        // 上一次快照尚未返回时不发起新请求，避免弱网环境下请求堆积。
        if (liveSnapshotRequestRef.current) return Promise.resolve()
        liveSnapshotRequestRef.current = true
        return axios.get(API_ROUTES.game_liveSnapshot, {
            params: {
                gameId: gameDetail.id
            }
        })
            .then(function (response) {
                if (response.data?.code !== 200 || !response.data?.data) return
                const snapshot = response.data.data || {}
                setLiveGameSnapshot(snapshot)
                setGameEventInfo(snapshot.eventList || [])
                const serverTime = Number(snapshot.serverTime)
                if (Number.isFinite(serverTime) && serverTime > 0) {
                    // 使用服务端时钟修正手机本地时间偏差，但后续秒表仍由前端自行推进。
                    serverClockOffsetRef.current = serverTime - Date.now()
                    setLiveNow(Date.now() + serverClockOffsetRef.current)
                }
                if (Number(snapshot.status) !== 2
                    && Number(gameDetail?.status) === 2
                    && !liveStatusRefreshRequestedRef.current) {
                    liveStatusRefreshRequestedRef.current = true
                    getCloseGameInfo?.()
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
            })
            .finally(() => {
                liveSnapshotRequestRef.current = false
            });
    }, [gameDetail?.id, gameDetail?.status, getCloseGameInfo])

    useEffect(() => {
        if (!gameDetail?.id) return;
        if (gameDetail.gameType === 3 || gameDetail.status === 0) {
            getBirthdayInfo()
        }
    }, [gameDetail?.id, gameDetail?.status, gameDetail?.gameType, getBirthdayInfo]);

    useEffect(() => {
        if (!gameDetail?.id) return;
        if (gameDetail.status === 2) {
            liveStatusRefreshRequestedRef.current = false
            getGameEventInfo()
        } else {
            // 首页最近赛事只在比赛进行中拉取赛况，避免非直播比赛进入页面时额外请求事件接口。
            setGameEventInfo([])
            setLiveGameSnapshot(null)
            return;
        }

        // 10 秒一次轻量快照即可满足首页展示，秒表本身完全在本地推进，不请求后端。
        const eventRefreshTimer = window.setInterval(() => {
            if (document.visibilityState === 'visible') {
                getGameEventInfo()
            }
        }, 10000)
        return () => window.clearInterval(eventRefreshTimer)
    }, [gameDetail?.id, gameDetail?.status, getGameEventInfo]);

    useEffect(() => {
        if (gameDetail?.status !== 2) return undefined;
        setLiveNow(Date.now() + serverClockOffsetRef.current)
        const liveClockTimer = window.setInterval(() => {
            setLiveNow(Date.now() + serverClockOffsetRef.current)
        }, 1000)
        return () => window.clearInterval(liveClockTimer)
    }, [gameDetail?.id, gameDetail?.status]);

    const parseGameEventTime = (value) => {
        if (!value) return null;
        if (value instanceof Date) return value;
        if (typeof value === 'number') return new Date(value);
        // iOS H5 对 yyyy-MM-dd HH:mm:ss 解析不稳定，统一替换成斜杠格式。
        const parsedDate = new Date(String(value).replace(/-/g, '/'));
        return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    const isCourseStartEvent = (item) => ["8", "10"].includes(String(item?.eventId));

    const isCourseEndEvent = (item) => String(item?.eventId) === "7";

    const isPauseToggleEvent = (item) => String(item?.eventId) === "18";

    const getSortedGameEvents = (events = []) => {
        return [...(events || [])].sort((a, b) => {
            const aTime = parseGameEventTime(a.currentTime)?.getTime() || 0;
            const bTime = parseGameEventTime(b.currentTime)?.getTime() || 0;
            return aTime - bTime;
        });
    }

    const getLiveCourseState = (events = []) => {
        const sortedEvents = getSortedGameEvents(events);
        const totalCourse = Number(gameDetail?.gameCourse ?? gameDetail?.gameCource)
            || Math.max(sortedEvents.filter(isCourseStartEvent).length, sortedEvents.filter(isCourseEndEvent).length, 1);
        let courseIndex = 0;
        let liveStartIndex = -1;
        let isLive = false;

        sortedEvents.forEach((item, index) => {
            if (isCourseStartEvent(item)) {
                courseIndex += 1;
                liveStartIndex = index;
                isLive = true;
            }
            if (isCourseEndEvent(item) && isLive) {
                isLive = false;
            }
        });

        return {
            sortedEvents,
            totalCourse,
            isLive,
            currentCourse: Math.min(Math.max(courseIndex, 1), totalCourse),
            waitingCourse: Math.min(Math.max(courseIndex + 1, 1), totalCourse),
            liveStartIndex,
            liveStartEvent: liveStartIndex >= 0 ? sortedEvents[liveStartIndex] : null,
        };
    }

    const getPausedSeconds = (events = [], boundaryDate) => {
        const pauseEvents = getSortedGameEvents(events).filter(isPauseToggleEvent);
        return pauseEvents.reduce((total, pauseEvent, index) => {
            if (index % 2 !== 0) return total;
            const pauseStart = parseGameEventTime(pauseEvent?.currentTime);
            const pauseEnd = parseGameEventTime(pauseEvents[index + 1]?.currentTime) || boundaryDate;
            if (!pauseStart || !pauseEnd || pauseEnd.getTime() <= pauseStart.getTime()) return total;
            return total + Math.floor((pauseEnd.getTime() - pauseStart.getTime()) / 1000);
        }, 0);
    }

    const getCourseElapsedSeconds = (startValue, endValue, events = [], fallbackSeconds = 0) => {
        const startDate = parseGameEventTime(startValue);
        const endDate = parseGameEventTime(endValue) || new Date(liveNow);
        if (!startDate || endDate.getTime() < startDate.getTime()) return Math.max(fallbackSeconds, 0);

        const wallSeconds = Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
        const elapsedSeconds = wallSeconds - getPausedSeconds(events, endDate);
        // 单节墙钟超过四小时通常是服务端时间异常，此时使用最后一条事件的比赛时间兜底。
        if (!Number.isFinite(elapsedSeconds) || elapsedSeconds < 0 || elapsedSeconds > 14400) {
            return Math.max(fallbackSeconds, 0);
        }
        // 时间戳完整时以“墙钟时间 - 暂停时间”为准，不能再用未扣暂停的 eventTime 把结果顶回去。
        return Math.max(elapsedSeconds, 0);
    }

    const getLiveCourseMinutes = (liveState) => {
        const sectionEvents = liveState?.sortedEvents?.slice((liveState?.liveStartIndex ?? -1) + 1) || [];
        const lastEventSeconds = sectionEvents
            .filter(item => !isCourseEndEvent(item))
            .map(item => Number(item.eventTime))
            .filter(value => Number.isFinite(value) && value >= 0)
            .reduce((max, value) => Math.max(max, value), 0);
        return Math.floor(getCourseElapsedSeconds(
            liveState?.liveStartEvent?.currentTime,
            null,
            sectionEvents,
            lastEventSeconds
        ) / 60);
    }

    const getEventIdValue = (item) => String(item?.eventId ?? item?.event_id ?? '');

    const isPenaltyEvent = (item) => ["12", "21"].includes(getEventIdValue(item));

    const isOwnGoalEvent = (item) => getEventIdValue(item) === "4";

    const isGoalEvent = (item) => ["3", "4", "9", "11", "12", "13", "14", "15", "16", "19", "20", "21"].includes(getEventIdValue(item));

    const isCardEvent = (item) => ["5", "6"].includes(getEventIdValue(item));

    const isLiveSummaryEvent = (item) => isGoalEvent(item) || isCardEvent(item);

    const getLiveSummaryIcon = (item) => {
        const eventId = getEventIdValue(item);
        if (eventId === "4") return Icon.OWN_GOAL;
        if (eventId === "9") return Icon.PENALTY_NOT_SCORED;
        if (["12", "21"].includes(eventId)) return Icon.PENALTY_KICK;
        if (isGoalEvent(item)) return Icon.GOAL;
        return "";
    }

    const getLiveSummaryClass = (item) => {
        const eventId = getEventIdValue(item);
        if (eventId === "5") return "yellow-card";
        if (eventId === "6") return "red-card";
        if (eventId === "9") return "penalty-miss";
        if (isPenaltyEvent(item)) return "penalty";
        if (isOwnGoalEvent(item)) return "own-goal";
        return "goal";
    }

    const getLiveSummaryTime = (item) => {
        const seconds = Number(item?.eventTime);
        if (Number.isFinite(seconds) && seconds >= 0) {
            return `${Math.floor(seconds / 60)}'`;
        }
        if (item?.eventTimeName) return item.eventTimeName;
        return '';
    }

    const getLiveSummaryPlayer = (item) => {
        if (item?.userName) return item.userName;
        if (item?.memberName) return item.memberName;
        if (item?.eventInfo) return item.eventInfo;
        return '未记录';
    }

    const getLiveDisplayName = (item) => {
        const name = getLiveSummaryPlayer(item);
        // 两字姓名中间补中文空格，保证左右时间轴中的名字视觉宽度统一。
        if (name && name.length === 2) {
            return `${name.charAt(0)}　${name.charAt(1)}`;
        }
        return name;
    }

    const getLiveSummarySortTime = (item) => {
        const seconds = Number(item?.eventTime);
        if (Number.isFinite(seconds) && seconds >= 0) return seconds;
        return parseGameEventTime(item?.currentTime)?.getTime() || 0;
    }

    const buildLiveEventCourses = (events = []) => {
        const sortedEvents = getSortedGameEvents(events);
        const totalCourse = Number(gameDetail?.gameCourse ?? gameDetail?.gameCource)
            || Math.max(sortedEvents.filter(isCourseStartEvent).length, sortedEvents.filter(isCourseEndEvent).length, 1);
        const courses = Array.from({ length: Math.max(totalCourse, 1) }, (_, index) => ({
            index: index + 1,
            rowMap: new Map(),
            started: false,
            ended: false,
            startTime: null,
            endTime: null,
            maxEventSeconds: 0,
            events: []
        }));
        let currentCourse = 0;

        sortedEvents.forEach((item) => {
            if (isCourseStartEvent(item)) {
                currentCourse += 1;
                const safeCourse = Math.min(Math.max(currentCourse, 1), courses.length);
                courses[safeCourse - 1].started = true;
                courses[safeCourse - 1].startTime = item?.currentTime;
                return;
            }
            if (isCourseEndEvent(item)) {
                const safeCourse = Math.min(Math.max(currentCourse || 1, 1), courses.length);
                courses[safeCourse - 1].ended = true;
                courses[safeCourse - 1].endTime = item?.currentTime;
                return;
            }
            const safeCourse = Math.min(Math.max(currentCourse || 1, 1), courses.length);
            const targetCourse = courses[safeCourse - 1];
            targetCourse.events.push(item);
            const eventSeconds = Number(item?.eventTime);
            if (Number.isFinite(eventSeconds) && eventSeconds >= 0) {
                targetCourse.maxEventSeconds = Math.max(targetCourse.maxEventSeconds, eventSeconds);
            }
            if (!isLiveSummaryEvent(item)) return;

            // 首页赛况按队伍左右分栏展示，gameTeam=1 为左侧队伍，gameTeam=2 为右侧队伍。
            const targetSide = Number(item?.gameTeam) === 2 ? 'right' : 'left';
            const rowKey = getLiveSummaryTime(item) || '--';
            if (!targetCourse.rowMap.has(rowKey)) {
                targetCourse.rowMap.set(rowKey, {
                    key: rowKey,
                    sortTime: getLiveSummarySortTime(item),
                    left: [],
                    right: []
                });
            }
            targetCourse.rowMap.get(rowKey)[targetSide].push(item);
        });

        const getCourseMinutes = (course) => {
            const seconds = getCourseElapsedSeconds(
                course.startTime,
                course.ended ? course.endTime : null,
                course.events,
                course.maxEventSeconds || 0
            );
            return Math.max(Math.floor(seconds / 60), 0);
        }

        return courses
            .map(course => ({
                index: course.index,
                started: course.started,
                durationText: `${getCourseMinutes(course)}'`,
                rows: Array.from(course.rowMap.values()).sort((a, b) => a.sortTime - b.sortTime)
            }))
            .filter(course => course.started || course.rows.length);
    }

    const renderLiveTimelineItem = (item, side) => (
        <div className={`home-live-timeline-event home-live-timeline-event--${side}`} key={item.id || `${getEventIdValue(item)}-${getLiveSummaryTime(item)}-${getLiveSummaryPlayer(item)}`}>
            {side === 'left' && <span className="home-live-timeline-name">{getLiveDisplayName(item)}</span>}
            <span className={`home-live-timeline-icon home-live-timeline-icon--${getLiveSummaryClass(item)}`}>
                {isCardEvent(item) ? null : (
                    <Image
                        src={getLiveSummaryIcon(item)}
                        width={15}
                        height={15}
                        fit='cover'
                        alt=""
                        style={{ backgroundColor: '#fff', borderRadius: '50%' }}
                    />
                )}
            </span>
            {side === 'right' && <span className="home-live-timeline-name">{getLiveDisplayName(item)}</span>}
        </div>
    )

    const renderLiveEventSummary = () => {
        if (gameDetail?.status !== 2) return null;
        const liveEventSource = liveGameSnapshot ? gameEventInfo : (gameDetail?.gameEventInfoVOList || []);
        const liveEventCourses = buildLiveEventCourses(liveEventSource);

        return (
            <div className="home-live-event-panel">
                <div className="home-live-event-head">
                    <span className="home-live-event-pulse" />
                    <span>实时赛况</span>
                    <strong>{liveEventCourses.reduce((sum, item) => sum + item.rows.reduce((rowSum, row) => rowSum + row.left.length + row.right.length, 0), 0)}</strong>
                </div>
                {liveEventCourses.length > 0 ? (
                    <div className="home-live-timeline">
                        {liveEventCourses.map(course => (
                            <div className="home-live-timeline-course" key={course.index}>
                                <div className="home-live-timeline-course-title">
                                    <span />
                                    <strong>第{course.index}节 <em>{course.durationText}</em></strong>
                                    <span />
                                </div>
                                <div className="home-live-timeline-rows">
                                    {course.rows.length > 0 ? (
                                        course.rows.map(row => (
                                            <div className="home-live-timeline-row" key={`${course.index}-${row.key}`}>
                                                <div className="home-live-timeline-side home-live-timeline-side--left">
                                                    {row.left.map(item => renderLiveTimelineItem(item, 'left'))}
                                                </div>
                                                <div className="home-live-timeline-minute">{row.key}</div>
                                                <div className="home-live-timeline-side home-live-timeline-side--right">
                                                    {row.right.map(item => renderLiveTimelineItem(item, 'right'))}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="home-live-timeline-no-event">本节暂无进球/牌</div>
                                    )}
                                    <div className="home-live-timeline-center-line" />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="home-live-event-empty">暂无进球或吃牌记录</div>
                )}
            </div>
        )
    }

    const gameInfo = () => {
        if (gameDetail.status === 0) {
            return (
                <div className="game-status-display game-status-display--registration">
                    <div className="game-status-header">

                        <span className="game-status-icon">📋</span>
                        <span className="game-status-title">报名中</span>
                    </div>
                </div>
            )
        } else if (gameDetail.status === 1) {
            return (
                <div className="game-status-display game-status-display--confirmed">
                    <div className="game-status-header">
                        <span className="game-status-icon">✅</span>
                        <span className="game-status-title">等待比赛开始</span>
                    </div>
                </div>
            )
        } else if (gameDetail.status === 2) {
            const recentEventList = liveGameSnapshot ? gameEventInfo : (gameDetail?.gameEventInfoVOList || [])
            const liveState = getLiveCourseState(recentEventList)
            const renderCourseMeta = (currentCourse) => (
                <span className="game-status-course">
                    <span className="game-status-course__label">赛段</span>
                    <span className="game-status-course__value">{currentCourse}/{liveState.totalCourse}</span>
                    <span className="game-status-course__unit">节</span>
                </span>
            )
            if (!liveState.isLive) {
                return (
                    <div className="game-status-display game-status-display--halftime">
                        <div className="game-status-header">
                            <div className="game-status-live-info">
                                <span className="game-status-title">{liveState.liveStartIndex < 0 ? '等待开球' : '中场休息'}</span>
                                {renderCourseMeta(liveState.liveStartIndex < 0 ? 1 : liveState.waitingCourse)}
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="game-status-display game-status-display--live">
                        <div className="game-status-header">
                            <div className="game-status-live-info">
                                <span className="game-status-live-dot" />
                                {renderCourseMeta(liveState.currentCourse)}
                                <span className="game-status-time">
                                    <span className="game-status-time__value">{getLiveCourseMinutes(liveState)}'</span>
                                </span>
                            </div>
                        </div>
                    </div>
                )
            }
        } else if (gameDetail.status === 3) {
            const recentEventList = gameDetail?.gameEventInfoVOList || []
            const startEvent = recentEventList?.filter(item => String(item.eventId) === "8")
            const endEvent = recentEventList?.filter(item => String(item.eventId) === "7")
            // 已结束赛事没有接口字段时，用开始/结束事件数量推算总节数。
            const totalCourse = Number(gameDetail?.gameCourse ?? gameDetail?.gameCource) || Math.max(startEvent.length, endEvent.length, 1)
            const currentCourse = Math.min(Math.max(startEvent.length, endEvent.length, 1), totalCourse)
            return (
                <div className="game-status-display game-status-display--finished">
                    <div className="game-status-header">
                        <span className="game-status-icon">🏁</span>
                        <span className="game-status-title">比赛已结束</span>
                        <span className="game-status-course">
                            <span className="game-status-course__label">赛段</span>
                            <span className="game-status-course__value">{currentCourse}/{totalCourse}</span>
                            <span className="game-status-course__unit">节</span>
                        </span>
                    </div>
                    <div className="game-status-score">
                        {gameDetail.greenGoal}&nbsp;:&nbsp;{gameDetail.redGoal}
                    </div>
                </div>
            )
        }
    }

    const gameTypeShow = (type) => {
        return (
            <div className="game-type-tag">
                <span className="game-type-tag__icon">⚔️</span>
                <span>{type}</span>
            </div>
        )
    }

    const isExternalMatch = () => [1, 2].includes(Number(gameDetail?.gameType ?? gameDetail?.game_type));

    const isKepengCupActivity = () => {
        const gameType = Number(gameDetail?.gameType ?? gameDetail?.game_type);
        const eventText = `${gameDetail?.gameName || ''} ${gameDetail?.gameRemark || ''}`;
        return gameType === 4 && eventText.includes('科朋杯');
    };

    const isValidTeamImage = (url) => typeof url === 'string' && url.startsWith('https');

    const withImageFooter = (url) => isValidTeamImage(url) ? url + Icon.ImageFooter : '';

    const getMemberDefaultAvatar = (member) => {
        // 外战对手作为临时队员保存，首页最近赛事优先按队员默认头像读取。
        const memberDefaultImage = member?.memberImageList?.find(item => Number(item.type) === 0)?.image;
        if (memberDefaultImage) return memberDefaultImage + Icon.ImageFooter;
        if (isValidTeamImage(member?.image)) return member.image + Icon.ImageFooter;
        if (isValidTeamImage(member?.memberImage)) return member.memberImage + Icon.ImageFooter;
        return '';
    }

    const getOpponentImage = () => {
        // 列表接口会批量返回临时对手队员头像，优先使用这个字段，避免 redCaptain 只有姓名时取不到图。
        return withImageFooter(gameDetail?.redCaptainImage) || getMemberDefaultAvatar(gameDetail?.redCaptain) || withImageFooter(gameDetail?.redImage) || withImageFooter(gameDetail?.redTeamLogo);
    }

    const getActivityTeamName = (team) => team === 1 ? getTeamName(1) : getTeamName(2);

    const isKepengTeam = (team) => {
        const teamName = getActivityTeamName(team);
        if (teamName.includes('科朋')) return true;

        // 活动赛队名可能只写“A队/B队”；未标明科朋归属时，默认绿队是科朋队。
        return team === 1
            && !getTeamName(1).includes('科朋')
            && !getTeamName(2).includes('科朋');
    };

    const getActivityTeamLogo = (team) => {
        // 科朋杯活动赛的科朋队固定使用俱乐部队徽，不读取队长头像。
        if (isKepengTeam(team)) return Icon.KEPENG_LOGO;

        // 对手队只读取队徽字段；后端用科朋默认图占位时按“无队徽”处理。
        const logo = team === 1 ? gameDetail?.greenTeamLogo : gameDetail?.redTeamLogo;
        const logoPath = typeof logo === 'string' ? logo.split('?')[0] : '';
        if (!logoPath || /\/kplogo\.png$/i.test(logoPath)) return '';
        return withImageFooter(logo);
    };

    const isActivityTeamNameFallback = (team) => isKepengCupActivity()
        && !isKepengTeam(team)
        && !getActivityTeamLogo(team);

    const teamLogos = (team) => {
        if (isKepengCupActivity()) {
            return getActivityTeamLogo(team);
        }
        if (isExternalMatch() && team === 1) {
            return Icon.KEPENG_LOGO;
        }
        if (isExternalMatch() && team === 2) {
            return getOpponentImage();
        }
        const logo = team === 1 ? gameDetail?.greenTeamLogo : gameDetail?.redTeamLogo;
        if (logo) return logo + Icon.ImageFooter;
        return Icon.KEPENG_LOGO;
    }

    const renderTeamLogo = (team, size = 58, className = 'match-team-avatar-wrap') => {
        const logoUrl = teamLogos(team);
        const teamName = team === 1 ? getTeamName(1) : getTeamName(2);
        const isFallback = isExternalMatch() && team === 2 && !logoUrl;
        const isNameFallback = isActivityTeamNameFallback(team);
        return (
            <div
                className={`${className} ${isFallback ? 'match-team-avatar-wrap--fallback' : ''} ${isNameFallback ? 'match-team-avatar-wrap--text-fallback' : ''}`}
                style={{ '--team-color': team === 1 ? (gameDetail?.greenColor || '#22c55e') : (gameDetail?.redColor || '#ef4444') }}
            >
                {isNameFallback ? (
                    <span className="match-team-fallback-name">{teamName}</span>
                ) : isFallback ? (
                    <>
                        <span className="match-team-fallback-ball">⚽</span>
                        <span className="match-team-fallback-name">{teamName}</span>
                    </>
                ) : (
                    <Image
                        src={logoUrl}
                        width={size}
                        height={size}
                        fit='cover'
                        style={{ borderRadius: '50%' }}
                    />
                )}
            </div>
        );
    }


    const renderStreakItems = ({
        items,
        flagKey,
        valueKey,
        compareValueKey,
        fireIcon,
        fireFilter,
        valueColor,
        minValue = 0,
        compareCondition = true
    }) => {
        // Helper to check birthday (ignores year)
        const isBirthdayMatch = (birthDateStr, gameDateStr) => {
            if (!birthDateStr || !gameDateStr) return false;
            try {
                // Ensure format YYYY-MM-DD
                const bDate = new Date(birthDateStr);
                const gDate = new Date(gameDateStr);
                return bDate.getMonth() === gDate.getMonth() && bDate.getDate() === gDate.getDate();
            } catch (e) {
                return false;
            }
        };

        // 过滤符合条件的项目
        const filteredItems = items?.filter(item => {
            if (flagKey === 'birthdayId') {
                const milestoneMatch = !!item.oneHundred || isBirthdayMatch(item.birthday, gameDetail.startDate || gameDetail.matchTime);
                return milestoneMatch && item.gameType === 0;
            }

            // 基础过滤条件：flag匹配且值大于等于最小值
            const baseCondition = item[flagKey] && item[valueKey] >= minValue;

            // 如果需要比较两个值不相等
            const comparisonCondition = compareValueKey
                ? item[valueKey] !== item[compareValueKey]
                : compareCondition;

            return baseCondition && comparisonCondition && item.gameType === 0;
        });

        // 如果没有符合条件的项目，不渲染
        if (!filteredItems || filteredItems.length === 0) return null;

        return filteredItems
            .sort((a, b) => b[valueKey] - a[valueKey])
            .map((item, index) => {
                let badgeIcon = '🔥';
                if (flagKey === 'birthdayId') {
                    if (item.oneHundred) {
                        badgeIcon = '👑'; // 百场
                    } else if (isBirthdayMatch(item.birthday, gameDetail.startDate || gameDetail.matchTime)) {
                        badgeIcon = '🎂'; // 生日
                    }
                }

                return (
                    <div className="achievement-badge" key={index}>
                        <div className="badge-text" style={{ flexShrink: 0 }}>
                            <span>{formatName(item.name)}</span>
                            <span style={{
                                display: 'inline-block',
                                transform: 'scaleX(0.75)',
                                transformOrigin: 'center center',
                                margin: '0 2px',
                                flexShrink: 0
                            }}>{badgeIcon}</span>
                            {item.oneHundred && <span style={{ fontWeight: '800', fontSize: '12px' }}>{item.oneHundred}x</span>}
                            {flagKey !== 'birthdayId' && <span style={{ marginLeft: '2px', fontWeight: '800' }}>{item[valueKey]}</span>}
                        </div>
                    </div>
                );
            });
    };


    // Redundant fetch removed as MatchResultDisplay handles its own data


    // 处理姓名格式的函数
    const formatName = (name) => {
        // 如果姓名是两个字，中间添加一个空格
        if (name.length === 2) {
            return name.charAt(0) + '　' + name.charAt(1);
        }
        // 其他长度保持不变
        return name;
    };


    const currentGameStatusShow = () => {

        if (gameDetail.status === 0) {
            // 首页与详情页共用报名、请假、待定卡片和底部操作面板。
            return <RegistrationActions
                gameId={gameDetail.id}
                gameType={gameDetail.gameType}
                memberId={memberInfo?.id}
                currentType={gameDetail.currentPeople?.gameType}
                counts={{ signup: gameDetail.currentPerson, leave: gameDetail.leavePerson, pending: gameDetail.undeterminedPerson }}
                mvpState={mvpDataInfo}
                isAdmin={Number(memberInfo?.admin) === 1}
                disabled={memberInfo?.temp === '1'}
                onChanged={() => Promise.all([getCloseGameInfo(), getGameInfo()])}
            />
        } else if (gameDetail?.status === 2) {
            const liveGreenGoal = liveGameSnapshot?.greenGoal ?? gameDetail.greenGoal ?? 0
            const liveRedGoal = liveGameSnapshot?.redGoal ?? gameDetail.redGoal ?? 0
            return (
                <div className="match-team-section">
                    <div className="match-status-bar">
                        {gameInfo()}
                    </div>

                    <div className="match-score-row">
                        <div className="match-team-item">
                            {renderTeamLogo(1)}
                            <div className="match-team-name">{getTeamName(1)}</div>
                        </div>

                        <div className="match-team-center">
                            <div className="game-status-score">
                                {liveGreenGoal} : {liveRedGoal}
                            </div>
                        </div>

                        <div className="match-team-item">
                            {renderTeamLogo(2)}
                            <div className="match-team-name">{getTeamName(2)}</div>
                        </div>
                    </div>

                    {renderLiveEventSummary()}
                </div>
            )
        } else if (gameDetail.status === 1) {
            return (
                <div className="prepared-matchup-card">
                    <div className="prepared-team">
                        {renderTeamLogo(1, 54, 'prepared-team-logo')}
                        {/* 待开赛时优先显示已命名队伍，未命名内讧赛显示当前队长姓氏。 */}
                        <div className="prepared-team-name">{getTeamName(1)}</div>
                    </div>
                    <div className="prepared-vs-center">
                        <span className="prepared-vs-label">VS</span>
                        <span className="prepared-status-pill">{getPreparedMatchStatusText()}</span>
                    </div>
                    <div className="prepared-team">
                        {renderTeamLogo(2, 54, 'prepared-team-logo')}
                        <div className="prepared-team-name">{getTeamName(2)}</div>
                    </div>
                </div>
            )
        }
    }

    const getStatusText = () => {
        if (gameDetail.status === 0) return '报名中';
        if (gameDetail.status === 1) return '已确认';
        if (gameDetail.status === 2) return '比赛中';
        if (gameDetail.status === 3) return '比赛结束';
        if (gameDetail.status === 4) return '比赛取消';
        if (gameDetail.status === 5) return '待发布';
        return '';
    };

    const getStatusClass = () => {
        if (gameDetail.status === 0) return 'pending';
        if (gameDetail.status === 1) return 'confirmed';
        if (gameDetail.status === 2) return 'live';
        if (gameDetail.status === 3) return 'finished';
        if (gameDetail.status === 4) return 'cancelled';
        if (gameDetail.status === 5) return 'draft';
        return 'pending';
    };

    return (
        <div className={`close-info-wrapper`}>
            {mvpVotePending && memberInfo?.temp !== '1' && gameDetail.status === 0 && (
                <NoticeBar
                    className={`premium-notice-bar ${mvpDataInfo?.clickInfo ? 'premium-notice-bar--error' : ''}`}
                    content={mvpDataInfo?.clickInfo
                        ? '你参加了上一场内讧赛，请先完成 MVP 投票再报名本场。'
                        : '上一场内讧赛 MVP 正在评选，可自愿投票；本场可直接报名。'}
                    icon={<span className="premium-notice-bar-icon" style={{ color: '#ef4444' }}>🏆</span>}
                    closeable
                />
            )}

            <div className="close-info-header">
                {/* 比赛类型与比赛状态属于同一级信息，固定在单场卡片顶部左右两侧。 */}
                <div className="close-info-meta-row">
                    <div className="close-info-tags">
                        {gameTypeShow(gameDetail?.gameTypeName)}
                        {gameDetail?.dinnerId && (
                            <div className="dinner-tag">
                                <span className="dinner-tag__icon">🎉</span>
                                <span>当日聚餐</span>
                            </div>
                        )}
                    </div>
                    <div className={`close-info-status-badge close-info-status-badge--${getStatusClass()}`}>
                        {getStatusText()}
                    </div>
                </div>
            </div>

            <div className="close-info-content">
                <div className="close-info-title-area">
                    <AutoCenter>
                        <div className="close-info-title" onClick={() => {
                            if (gameDetail.status === 0) {
                                navigate(`/games/${gameDetail.id}/signup`)
                            } else if (gameDetail.status === 1) {
                                navigate(`/games/${gameDetail.id}/ready`)
                            } else if (gameDetail.status === 2) {
                                navigate(`/games/${gameDetail.id}/live`)
                            } else if (gameDetail.status === 5) {
                                // 地址保留比赛编号，刷新编辑页时仍可重新读取当前比赛选项。
                                navigate(`/gameUpdate?gameId=${gameDetail.id}`, { state: { gameDetail: gameDetail } })
                            }
                        }}>
                            {gameDetail.gameName}
                        </div>
                    </AutoCenter>

                    {gameDetail.status === 5 && (
                        <div className="admin-action-btn-group">
                            <Button
                                className="admin-btn-publish"
                                onClick={() => {
                                    Dialog.confirm({
                                        className: 'premium-dialog home-match-dialog',
                                        content: (
                                            <div className="premium-dialog-body">
                                                <div className="premium-dialog-title">确定发布比赛？</div>
                                                <div className="premium-dialog-content">
                                                    成员将收到通知并可开始报名。
                                                </div>
                                            </div>
                                        ),
                                        onConfirm: () => {
                                            axios.post(API_ROUTES.game_changeGameInfo, {
                                                id: gameDetail.id,
                                                status: 0
                                            }, null)
                                                .then(function (response) {
                                                    if (response.data.code === 200) {
                                                        window.location.reload()
                                                    } else {
                                                        Toast.show({ icon: 'fail', content: response.data.msg })
                                                    }
                                                })
                                                .catch(function (error) {
                                                    Toast.show({ icon: 'fail', content: "操作失败" })
                                                })
                                        },
                                    });
                                }}
                            >
                                发布比赛
                            </Button>
                            <Button
                                className="admin-btn-cancel"
                                onClick={() => {
                                    Dialog.confirm({
                                        className: 'premium-dialog home-match-dialog',
                                        content: (
                                            <div className="premium-dialog-body">
                                                <div className="premium-dialog-title">确定取消？</div>
                                                <div className="premium-dialog-content">
                                                    比赛将被标记为已取消。
                                                </div>
                                            </div>
                                        ),
                                        onConfirm: () => {
                                            axios.post(API_ROUTES.game_changeGameInfo, {
                                                id: gameDetail.id,
                                                status: 4
                                            }, null)
                                                .then(function (response) {
                                                    if (response.data.code === 200) {
                                                        window.location.reload()
                                                    } else {
                                                        Toast.show({ icon: 'fail', content: response.data.msg })
                                                    }
                                                })
                                                .catch(function (error) {
                                                    Toast.show({ icon: 'fail', content: "操作失败" })
                                                })
                                        },
                                    });
                                }}
                            >
                                取消比赛
                            </Button>
                        </div>
                    )}
                </div>

                {gameDetail.gameRemark && (
                    <AutoCenter className="close-info-remark">
                        {gameDetail.gameRemark}
                    </AutoCenter>
                )}

                <div className="close-info-data-row">
                    <div className="close-info-data-item">
                        <img src={Icon.GOAL} alt="" style={{ width: "16px" }} />
                        <span>{gameDetail.startDate} {gameDetail.startTime} ({gameDetail.week})</span>
                    </div>
                    <div className="close-info-data-item">
                        <span style={{ marginRight: '4px' }}>📍</span>
                        <span>{gameDetail.address}</span>
                    </div>

                    {gameDetail.status === 5 && (
                        <div className="close-info-data-item">
                            {gameDetail.type}
                        </div>
                    )}
                </div>

                <div className="achievement-wall">
                    {/* Birthdays and Milestones (Separate Row) */}
                    <div className="milestone-row">
                        {renderStreakItems({
                            items: memberBirthDay,
                            flagKey: 'birthdayId',
                            valueKey: 'birthdayValue',
                            fireIcon: Icon.FIRE_COLOR,
                            minValue: 1
                        })}
                    </div>

                    {/* Unbeaten and Winless Columns */}
                    <div className="streaks-grid">
                        <div className="streak-column">
                            <MatchResultDisplay memberBirthDay={memberBirthDay} count={5} trendType="unbeaten" />
                        </div>
                        <div className="streak-column">
                            <MatchResultDisplay memberBirthDay={memberBirthDay} count={5} trendType="winless" />
                        </div>
                    </div>

                    <GetSinglePersonFire memberBirthDay={memberBirthDay} />
                </div>

                {currentGameStatusShow()}
            </div>
        </div>
    )
}

export default CloseInfo
